/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/13/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Grid} from "@scuf/common";
import ExpandableCard from "../common/ExpandableCard";
import FaultCard from "../faults/list/FaultCard";

class FaultsListExpandable extends React.Component {

    getFaultCards(faults) {
        return faults.map(f => <Grid.Column key={f.id} width={4} sWidth={12}><FaultCard fault={f}/></Grid.Column>)
    }

    render() {
        const {faults} = this.props

        const faults1 = this.getFaultCards(faults.slice(0, 3))
        const faults2 = this.getFaultCards(faults.slice(3))

        return (
            <div className="faults-list-expandable">
                {faults1.length > 0 ?
                    <ExpandableCard
                        className='dashboard-card'
                        expandable={faults2.length > 0}
                        content={<Grid>{faults1}</Grid>}
                        expandedContent={<Grid>{faults2}</Grid>}
                        interactive={false}
                    />
                    :
                    null
                }
            </div>
        )
    }
}


export default injectIntl(FaultsListExpandable)